import { sceconfig } from 'sce-core';

export const environment = {
  production: true,
  logger: 'console',
  wmsApiBaseUrl: '../lfcoreservice/',
  baseUrlUI : sceconfig.wms.baseUrlUI,
  growthbookClientKey: 'sdk-f5Vv9EdVJgNSUW5S',
  growthbookHostApi: 'https://growthbook-proxy.fbm.maersk.com/',
  deploymentRegion: 'apa-cn'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/environments/environment.sit.ts